import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Sistema de moeda global — base: AOA (Kwanza). Valores armazenados em AOA.
let currencyConfig = { currency: "AOA", symbol: "Kz", rate: 1 };

export const setCurrencyConfig = ({ currency, symbol, rate }) => {
  currencyConfig = {
    currency: currency || "AOA",
    symbol: symbol || "Kz",
    rate: rate && rate > 0 ? rate : 1,
  };
};

export const getCurrencyConfig = () => currencyConfig;
export const getCurrencySymbol = () => currencyConfig.symbol;

const formatNumber = (value) =>
  new Intl.NumberFormat("pt-AO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0);

// Converte de AOA (base) para a moeda do sistema e formata
export const formatCurrency = (value) => {
  const { currency, symbol, rate } = currencyConfig;
  const converted = (value || 0) / rate;
  if (currency === "USD" || currency === "EUR") {
    return `${symbol} ${formatNumber(converted)}`;
  }
  return `${formatNumber(converted)} ${symbol}`;
};

// Formata um valor já expresso na moeda do sistema (sem converter)
export const formatDisplayAmount = (value) => {
  const { currency, symbol } = currencyConfig;
  const num = parseFloat(value) || 0;
  if (currency === "USD" || currency === "EUR") {
    return `${symbol} ${formatNumber(num)}`;
  }
  return `${formatNumber(num)} ${symbol}`;
};

// Converte um valor introduzido na moeda do sistema para AOA (base)
export const toBaseCurrency = (value) => (parseFloat(value) || 0) * currencyConfig.rate;

// Converte de AOA (base) para a moeda do sistema (número)
export const fromBaseCurrency = (value) => (value || 0) / currencyConfig.rate;

// Para eixos de gráficos: valor AOA convertido + símbolo, sem decimais
export const formatAxisCurrency = (value) => {
  const { symbol } = currencyConfig;
  const v = fromBaseCurrency(value);
  const compact = new Intl.NumberFormat("pt-AO", { maximumFractionDigits: 0 }).format(v);
  return `${compact} ${symbol}`;
};

// Data de hoje (AAAA-MM-DD) no fuso de Luanda — igual à usada pelo servidor nas presenças
export const todayLuanda = () => new Intl.DateTimeFormat("sv-SE", { timeZone: "Africa/Luanda" }).format(new Date());


export const formatDate = (date, locale = "pt-AO") => {
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(date));
};

export const formatTime = (date, locale = "pt-AO") => {
  return new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(date));
};

export const getStatusColor = (status) => {
  const colors = {
    free: "status-free",
    occupied: "status-occupied",
    reserved: "status-reserved",
    cleaning: "status-cleaning",
    open: "bg-amber-500/20 text-amber-500",
    preparing: "bg-blue-500/20 text-blue-500",
    ready: "bg-emerald-500/20 text-emerald-500",
    completed: "bg-slate-500/20 text-slate-400",
    cancelled: "bg-red-500/20 text-red-500",
    pending: "bg-amber-500/20 text-amber-500",
    paid: "bg-emerald-500/20 text-emerald-500",
  };
  return colors[status] || "bg-muted text-muted-foreground";
};

// Sessões em cookie HttpOnly (SameSite=Lax) só são enviadas em pedidos same-origin: quando a app é servida
// por um domínio próprio (novo domínio do cliente), o /api é servido pelo mesmo host, por isso a API segue a origem
// da página. Em localhost/dev e como fallback mantém-se REACT_APP_BACKEND_URL.
const resolveBackendUrl = () => {
  const configured = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return configured;
  const { origin, hostname, protocol } = window.location;
  if (protocol !== "https:" || hostname === "localhost" || hostname === "127.0.0.1") return configured;
  return origin;
};

export const BACKEND_URL = resolveBackendUrl();
export const API_URL = BACKEND_URL + "/api";

// Resolve URLs relativas (/api/files/..., /api/uploads/...) para o backend
export const resolveMediaUrl = (url) => {
  if (!url) return "";
  return url.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
};
